import { patch } from './restApi';

export const getRevenueReportByEngineering = (payload) => {
    return patch('revenueReportByEngineeringTeam/get-revenue-report-by-engineering', {
        ...payload
    });
};